import {Task} from '../Task';

export class TaskFilterModel{
  SearchInput: string = "";
  ResponsibleInput: string = "";
  ToBeDoneByInput: string = "";
  StatusInput: string = "";
  JobNoInput: string = "";
  //pageNo: number;
  pageSize: number;
  //pageTotal: number;
  task_: Task;
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/filter-models/TaskFilterModel.ts